module.exports = __webpack_public_path__ + "img/oneBlue.381d3d72.jpg";